// Переводы лендинга. Русская строка подбирается по длине английской: тексты
// стоят в сетке секций, и разница в длине ломает переносы.
export default {
  app: {
    en: {
      welcome: 'Welcome',

      header: {
        home: 'Dobroverse home',
        nav: 'Main navigation',
        menu: 'Menu',
        howItWorks: 'How it works',
        places: 'Places',
        packages: 'Packages',
        action: 'Choose Dobro',
      },

      hero: {
        titleTop: 'One pass.',
        titleLead: 'All the',
        titleAccent: 'good.',
        leadFirst: 'Local places, useful perks and an easier arrival in Phuket.',
        leadSecond: 'Get the Pass — or go Black with a personal assistant.',
        offer: 'Dobro Pass',
        price: '$20',
        action: 'Choose your Dobro',
        note: 'One Pass for two, for a trip of up to 30 days.',
        cardPassTo: 'YOUR PASS TO',
        cardPerks: 'COFFEE · FOOD · WELLNESS',
        cardAndMore: 'AND MORE',
        cardNightlife: 'NIGHTLIFE + MORE',
      },

      motto: {
        titleTop: 'Tourist for a week.',
        titleAccent: 'Local',
        titleTail: 'from day one.',
        leadFirst: 'From the airport to the places worth knowing,',
        leadSecond: 'Dobro handles the practical stuff and gets you to the good stuff.',
        conclusion: 'That’s the whole idea.',
      },

      benefits: {
        titleTop: 'Your $20',
        titleBottom: 'goes a long way.',
        lead: 'Free arrival prep, member prices and gifts at Dobro places — one Pass for the whole trip.',
        valueLabel: 'Value you get',
        value: '$50',
        valueNote: 'One day of perks',
        priceLabel: 'Dobro Pass',
        price: '$20',
        priceNote: 'Per trip, for two',
        save: 'Save up to $30.',
        disclaimer: 'Illustrative day for one card: lunch perk, massage upgrade, 5% off a $60 island tour and a first drink. Final value depends on places and availability.',
        included: 'Included',
        free: 'Free',
        memberPrice: 'Member price',
        prep: {
          title: 'Arrival prep',
          description: 'TDAC and document\nchecklist before you fly.',
        },
        lunch: {
          title: 'Lunch perk',
          description: 'Local favorites,\nmember price.',
          retailPrice: '$17',
          memberPrice: '$9',
        },
        massage: {
          title: 'Massage upgrade',
          description: 'Treat yourself.\nOn us.',
          retailPrice: '$25',
        },
        tour: {
          title: 'Island tour',
          description: 'A day on the boat,\nless to pay.',
          retailPrice: '$60',
          memberPrice: '$57',
          discount: '−5 %',
        },
        bar: {
          title: 'Night out',
          description: 'Your first drink is on us\nat a participating Dobro bar.',
          retailPrice: '$14',
        },
      },

      application: {
        sentTitle: 'Request sent',
        sentNote: 'We got it. The Dobro team answers on WhatsApp or by email within one day.',
        close: 'Close',
        titleQuestion: 'Ask the Dobro team',
        titleBooking: 'Book your Dobro',
        stepPackage: 'Choice',
        stepQuestion: 'Question',
        stepArrival: 'Arrival',
        stepContacts: 'Contacts',
        plans: 'Plans',
        services: 'Services',
        dateQuestion: 'When do you land?',
        flightPlaceholder: 'Flight number, for example TG201',
        hotelPlaceholder: 'Hotel or area in Phuket',
        guestsQuestion: 'Who is arriving?',
        guestsNote: 'Priced per person. Children under 2 are free.',
        carNote: 'Priced per car: sedan up to 3 people, minivan for more.',
        people: 'people',
        adults: 'Adults',
        children: 'Children',
        adultLess: 'One adult less',
        adultMore: 'One adult more',
        childLess: 'One child less',
        childMore: 'One child more',
        askQuestion: 'What would you like to know?',
        questionPlaceholder: 'Your question',
        contactsQuestion: 'How do we reach you?',
        namePlaceholder: 'Your name',
        emailPlaceholder: 'Email',
        phonePlaceholder: 'WhatsApp number',
        commentPlaceholder: 'Anything else: car seat, late flight, special request…',
        contactsNote: 'We answer on WhatsApp or by email. No newsletters.',
        emptySummary: 'Pick your Dobro to see the price',
        back: 'Back',
        next: 'Next',
        sending: 'Sending…',
        send: 'Send request',
        nameError: 'Please tell us your name.',
        emailError: 'Please enter a valid email.',
        sendError: 'We could not send your request. Please try again.',
      },

      faq: {
        titleTop: 'Questions?',
        titleAccent: 'We got you.',
        contact: 'Still have questions? Hit us up anytime',
        contactAction: 'ask the Dobro team',
        choose: {
          title: 'Which Dobro should I choose?',
          answer: 'Choose Pass to explore on your own. Choose Black for a personal assistant, a trip plan and $100 to spend on services.',
        },
        passStart: {
          title: 'When does my Pass start?',
          answer: 'Your Pass covers one trip of up to 30 days and starts when you use your first perk in Phuket.',
        },
        app: {
          title: 'Do I need an app?',
          answer: 'Nope! Dobro works in your browser. Just show your pass.',
        },
        repeat: {
          title: 'Can I use the same perk more than once?',
          answer: 'Each perk can be used once per day. Come back tomorrow!',
        },
        coverage: {
          title: 'Where does Dobro work?',
          answer: 'All over Phuket. From north to south — more spots added regularly.',
        },
        transfer: {
          title: 'Is the airport transfer private?',
          answer: 'Yes. Your confirmed vehicle goes directly from Phuket Airport to your hotel without shared stops.',
        },
        delay: {
          title: 'What if my flight is delayed?',
          answer: 'We track your flight and adjust the meeting time. If anything changes, our team stays in touch with you.',
        },
        welcome: {
          title: 'What does Dobro Black include?',
          answer: 'Everything in Pass, a personal assistant in WhatsApp, Black perks at places, a trip plan, −10 % on all services and $100 to spend on services.',
        },
        documents: {
          title: 'Do you help with visas and TDAC?',
          answer: 'We help you prepare with an official requirements checklist and TDAC guidance. The free TDAC form and any visa application remain official government processes.',
        },
        fastTrack: {
          title: 'Does Fast Track guarantee entry?',
          answer: 'Fast Track is designed to reduce waiting and guide you through the available airport route. Thai immigration makes every entry decision.',
        },
      },

      cta: {
        titleTop: 'Make Phuket',
        titleLead: 'a little more',
        titleAccent: 'Dobro.',
        leadFirst: 'Local perks, a personal assistant and arrival services.',
        leadSecond: 'Choose only what you need.',
        people: 'Good people',
        places: 'Good places',
        times: 'Good times',
        action: 'Get Dobro Pass',
      },

      plans: {
        titleTop: 'Pick the Dobro',
        titleLead: 'that fits',
        titleAccent: 'your trip.',
        lead: 'Two plans for the whole trip. Arrival services and tours are in the catalog: open to all, cheaper with Black.',
        terms: 'One-time purchase for two, for one trip of up to 30 days. The Pass starts when you use your first perk in Phuket.',
        noteFinalPrice: 'Final Fast Track and transfer prices depend on flight time, party size and hotel area.',
        noteAirport: 'Airport access and processing times depend on airport procedures. Entry decisions remain with Thai authorities.',
        catalogTitle: 'Services catalog',
        catalogLead: 'Open to everyone. Pay only for what you need.',
        blackDiscount: '−10 % with Black',
        book: 'Book',
        units: {
          free: 'for everyone',
          person: 'per person',
          car: 'per car',
        },
        pass: {
          label: 'For two',
          description: 'For travelers who want to explore Phuket their own way.',
          features: 'All Dobro places and perks\nOne trip up to 30 days\nWhatsApp support\nServices at catalog price',
          cta: 'Get Dobro Pass',
          priceNote: 'per trip · for two',
          price: '$20',
        },
        black: {
          label: 'Personal care',
          description: 'For travelers who want a person to plan and book for them.',
          features: 'Everything in Dobro Pass\nPersonal assistant in WhatsApp\nBlack perks at places\nTrip plan for your interests\n−10 % on all services\n$100 to spend on services',
          cta: 'Get Dobro Black',
          priceNote: 'per trip · for two',
          price: '$199',
        },
        services: {
          prep: {
            title: 'Arrival prep',
            description: 'TDAC and document checklist before you fly.',
            price: 'Free',
          },
          fastTrack: {
            title: 'Fast Track Standard',
            description: 'Priority lane through passport control.',
            price: 'From $45',
          },
          fastTrackVip: {
            title: 'Fast Track VIP',
            description: 'Meet at the gate, bags, customs and exit to your car.',
            price: 'From $106',
          },
          transfer: {
            title: 'Private transfer',
            description: 'Airport to your hotel. Sedan up to 3 people.',
            price: 'From $56',
          },
          tours: {
            title: 'Island tours',
            description: 'Boat trips and day tours with Dobro partners.',
            price: 'Partner price',
          },
        },
        question: {
          title: 'Just a question',
          priceNote: 'we answer within a day',
          price: '—',
        },
      },

      howItWorks: {
        titleLead: 'How',
        titleAccent: 'Dobro',
        titleTail: 'works.',
        lead: 'Book once before your trip. We arrange the services in your package.',
        bannerTitle: 'From landing to local.',
        bannerNote: 'That’s the Dobro way.',
        choose: {
          title: 'Choose your Dobro',
          description: 'Choose Pass or Black,\nthen add the services you need.',
        },
        details: {
          title: 'Send arrival details',
          description: 'Share your flight number and\nthe address where you are staying.',
        },
        arrive: {
          title: 'Arrive with Dobro',
          description: 'Your booked airport services and\ntransfer are ready when you land.',
        },
      },

      features: {
        titleTop: 'Not a discount card.',
        titleLead: 'Your shortcut to',
        titleAccent: 'Phuket.',
        leadFirst: 'Start with the Pass and add only the services you need.',
        leadSecond: 'Every option leads to the same good places,',
        leadThird: 'local perks and people who can help.',
        pass: {
          title: 'Dobro Pass',
          description: 'One trip of up to 30 days with places, local perks and member benefits.',
        },
        assist: {
          title: 'Meet & Fast Track',
          description: 'Your airport host meets you on arrival and guides you through the priority route. Priced per person.',
        },
        transfer: {
          title: 'Private transfer',
          description: 'Your flight is tracked and your driver takes you directly to your stay. Priced per car.',
        },
        prep: {
          title: 'Arrival prep',
          description: 'Get a clear TDAC and document checklist before you fly. Free for everyone.',
        },
        support: {
          title: '24/7 Support',
          description: 'A real person is available around the clock when your arrival plans change.',
        },
      },

      places: {
        titleTop: 'Good places',
        titleLead: 'are',
        titleAccent: 'Dobro',
        titleTail: 'places.',
        leadFirst: 'Carefully picked spots across Phuket',
        leadSecond: 'with perks for Dobro members.',
        categoriesLabel: 'Place categories',
        previous: 'Previous places',
        next: 'Next places',
        action: 'Explore all Dobro Spots',
        categories: {
          all: 'All',
          coffee: 'Coffee',
          food: 'Food',
          wellness: 'Wellness',
          nightlife: 'Nightlife',
          activities: 'Things to do',
        },
        bartels: {
          area: 'Specialty Coffee · Bang Tao',
          perk: 'Free coffee',
          detail: 'with any breakfast',
        },
        suay: {
          area: 'Modern Thai · Cherngtalay',
          perk: '10% off',
          detail: 'food & drinks',
        },
        oasis: {
          area: 'Spa & Wellness · Kata',
          perk: 'Free 30 min',
          detail: 'aromatherapy upgrade',
        },
        catch: {
          area: 'Beach Club · Bang Tao',
          perk: 'Welcome drink',
          detail: 'upon arrival',
        },
        simba: {
          area: 'Boat Tours · Chalong',
          perk: '5% off',
          detail: 'island day trips',
        },
        campus: {
          area: 'Coffee Roastery · Old Town',
          perk: 'Free dessert',
          detail: 'with any coffee',
        },
      },

      footer: {
        tagline: 'Your pass to good places, useful perks and an easier arrival in Phuket.',
        request: 'Leave a request',
        explore: 'Explore',
        howItWorks: 'How it works',
        places: 'Dobro places',
        packages: 'Plans',
        faq: 'FAQ',
        brand: 'Dobroverse',
        about: 'About Dobro',
        forPlaces: 'For places',
        contact: 'Contact',
        getPass: 'Get Dobro Pass',
        follow: 'Follow us',
        followNote: 'Fresh places, perks and Phuket tips.',
        onInstagram: 'Dobroverse on Instagram',
        onTiktok: 'Dobroverse on TikTok',
        onFacebook: 'Dobroverse on Facebook',
        rights: '© 2026 Dobro Pass. All rights reserved.',
        terms: 'Terms',
        privacy: 'Privacy',
        madeIn: 'Made in Phuket',
      },
    },
    ru: {
      welcome: 'Добро пожаловать',

      header: {
        home: 'Главная Dobroverse',
        nav: 'Главное меню',
        menu: 'Меню',
        howItWorks: 'Как работает',
        places: 'Места',
        packages: 'Пакеты',
        action: 'Выбрать Dobro',
      },

      hero: {
        titleTop: 'Одна карта.',
        titleLead: 'Только',
        titleAccent: 'добро.',
        leadFirst: 'Хорошие места, выгодные скидки и помощь с приездом на Пхукет.',
        leadSecond: 'Возьмите Pass — или Black с личным помощником.',
        offer: 'Dobro Pass',
        price: '1 600 ₽',
        action: 'Выбрать своё Dobro',
        note: 'Одна карта на двоих, на поездку до 30 дней.',
        cardPassTo: 'КАРТА ДАЁТ',
        cardPerks: 'КОФЕ · ЕДА · ЗДОРОВЬЕ',
        cardAndMore: 'А ТАКЖЕ',
        cardNightlife: 'БАРЫ И НЕ ТОЛЬКО',
      },

      motto: {
        titleTop: 'Турист на неделю.',
        titleAccent: 'Свой',
        titleTail: 'с первого дня.',
        leadFirst: 'От аэропорта до мест, которые стоит знать,',
        leadSecond: 'Dobro берёт на себя бытовые дела и ведёт вас к хорошим местам.',
        conclusion: 'В этом и вся идея.',
      },

      benefits: {
        titleTop: 'Ваши 1 600 ₽',
        titleBottom: 'окупаются сразу.',
        lead: 'Бесплатная подготовка к приезду, цены для своих и подарки в местах Dobro — одна карта на всю поездку.',
        valueLabel: 'Реальная выгода',
        value: '4 000 ₽',
        valueNote: 'Один день скидок',
        priceLabel: 'Dobro Pass',
        price: '1 600 ₽',
        priceNote: 'За поездку, на двоих',
        save: 'Экономия до 2 400 ₽.',
        disclaimer: 'Пример дня по одной карте: обед, апгрейд массажа, 5% с тура на остров за 4 800 ₽ и первый напиток. Итог зависит от мест и наличия.',
        included: 'Включено',
        free: 'Бесплатно',
        memberPrice: 'Цена для своих',
        prep: {
          title: 'Подготовка',
          description: 'Список документов\nи TDAC до вылета.',
        },
        lunch: {
          title: 'Скидка на обед',
          description: 'Местная кухня,\nцена для своих.',
          retailPrice: '1 400 ₽',
          memberPrice: '750 ₽',
        },
        massage: {
          title: 'Массаж в подарок',
          description: 'Побалуйте себя.\nЗа наш счёт.',
          retailPrice: '2 000 ₽',
        },
        tour: {
          title: 'Тур на остров',
          description: 'День на лодке,\nплатите меньше.',
          retailPrice: '4 800 ₽',
          memberPrice: '4 560 ₽',
          discount: '−5 %',
        },
        bar: {
          title: 'Вечер в баре',
          description: 'Первый напиток за нами\nв барах-партнёрах Dobro.',
          retailPrice: '1 100 ₽',
        },
      },

      application: {
        sentTitle: 'Заявка отправлена',
        sentNote: 'Мы её получили. Команда Dobro ответит в WhatsApp или на почту за день.',
        close: 'Закрыть',
        titleQuestion: 'Спросить команду Dobro',
        titleBooking: 'Оформите Dobro',
        stepPackage: 'Выбор',
        stepQuestion: 'Вопрос',
        stepArrival: 'Прилёт',
        stepContacts: 'Контакты',
        plans: 'Тарифы',
        services: 'Услуги',
        dateQuestion: 'Когда прилетаете?',
        flightPlaceholder: 'Номер рейса, например TG201',
        hotelPlaceholder: 'Отель или район на Пхукете',
        guestsQuestion: 'Кто прилетает?',
        guestsNote: 'Цена за человека. Дети до 2 лет бесплатно.',
        carNote: 'Цена за машину: седан до 3 человек, дальше минивэн.',
        people: 'чел.',
        adults: 'Взрослые',
        children: 'Дети',
        adultLess: 'Один взрослый меньше',
        adultMore: 'Один взрослый больше',
        childLess: 'Один ребёнок меньше',
        childMore: 'Один ребёнок больше',
        askQuestion: 'Что вы хотите узнать?',
        questionPlaceholder: 'Ваш вопрос',
        contactsQuestion: 'Как с вами связаться?',
        namePlaceholder: 'Ваше имя',
        emailPlaceholder: 'Почта',
        phonePlaceholder: 'Номер WhatsApp',
        commentPlaceholder: 'Что-то ещё: детское кресло, ночной рейс, особая просьба…',
        contactsNote: 'Ответим в WhatsApp или на почту. Рассылок не шлём.',
        emptySummary: 'Выберите Dobro, чтобы увидеть цену',
        back: 'Назад',
        next: 'Дальше',
        sending: 'Отправляем…',
        send: 'Отправить заявку',
        nameError: 'Напишите, как вас зовут.',
        emailError: 'Введите правильный адрес почты.',
        sendError: 'Не удалось отправить заявку. Попробуйте ещё раз.',
      },

      faq: {
        titleTop: 'Вопросы?',
        titleAccent: 'Мы ответим.',
        contact: 'Остались вопросы? Пишите в любое время',
        contactAction: 'спросить команду Dobro',
        choose: {
          title: 'Какой Dobro выбрать?',
          answer: 'Pass — если едете сами. Black — если нужны личный помощник, план поездки и 8 000 ₽ на услуги.',
        },
        passStart: {
          title: 'Когда начинается карта?',
          answer: 'Карта действует одну поездку до 30 дней и включается с первой скидки на Пхукете.',
        },
        app: {
          title: 'Нужно ли приложение?',
          answer: 'Нет. Dobro работает в браузере. Просто покажите карту.',
        },
        repeat: {
          title: 'Можно ли повторить одну скидку?',
          answer: 'Каждая скидка работает раз в день. Приходите завтра.',
        },
        coverage: {
          title: 'Где работает Dobro?',
          answer: 'По всему Пхукету, с севера до юга. Мест становится больше.',
        },
        transfer: {
          title: 'Трансфер только для меня?',
          answer: 'Да. Машина едет из аэропорта Пхукета прямо в отель, без чужих остановок.',
        },
        delay: {
          title: 'А если рейс задержат?',
          answer: 'Мы следим за рейсом и сдвигаем время встречи. Если что-то меняется, команда на связи.',
        },
        welcome: {
          title: 'Что входит в Dobro Black?',
          answer: 'Всё из Pass, личный помощник в WhatsApp, Black-выгоды в местах, план поездки, −10 % на все услуги и 8 000 ₽ на услуги.',
        },
        documents: {
          title: 'Помогаете с визой и TDAC?',
          answer: 'Даём список официальных требований и подсказки по TDAC. Сама форма TDAC бесплатна, а визу оформляют государственные службы.',
        },
        fastTrack: {
          title: 'Fast Track гарантирует въезд?',
          answer: 'Fast Track сокращает ожидание и ведёт по доступному маршруту. Решение о въезде принимает миграционная служба Таиланда.',
        },
      },

      cta: {
        titleTop: 'Сделаем Пхукет',
        titleLead: 'чуть',
        titleAccent: 'добрее.',
        leadFirst: 'Местные скидки, личный помощник и услуги приезда.',
        leadSecond: 'Берите только то, что нужно.',
        people: 'Хорошие люди',
        places: 'Хорошие места',
        times: 'Хорошее время',
        action: 'Купить Dobro Pass',
      },

      plans: {
        titleTop: 'Выберите Dobro',
        titleLead: 'под',
        titleAccent: 'вашу поездку.',
        lead: 'Два тарифа на всю поездку. Услуги приезда и туры — в каталоге: открыт всем, с Black дешевле.',
        terms: 'Разовая покупка на двоих, на одну поездку до 30 дней. Карта включается с первой скидки на Пхукете.',
        noteFinalPrice: 'Итоговая цена Fast Track и трансфера зависит от времени рейса, числа гостей и района отеля.',
        noteAirport: 'Доступ в зоны и сроки прохождения зависят от правил аэропорта. Решение о въезде принимают власти Таиланда.',
        catalogTitle: 'Каталог услуг',
        catalogLead: 'Открыт всем. Платите только за нужное.',
        blackDiscount: '−10 % с Black',
        book: 'Заказать',
        units: {
          free: 'для всех',
          person: 'за человека',
          car: 'за машину',
        },
        pass: {
          label: 'На двоих',
          description: 'Для тех, кто хочет открывать Пхукет по-своему.',
          features: 'Все места и скидки Dobro\nОдна поездка до 30 дней\nПоддержка в WhatsApp\nУслуги по цене каталога',
          cta: 'Купить Dobro Pass',
          priceNote: 'за поездку · на двоих',
          price: '1 600 ₽',
        },
        black: {
          label: 'Личная забота',
          description: 'Для тех, кому нужен человек, который всё спланирует и забронирует.',
          features: 'Всё из Dobro Pass\nЛичный помощник в WhatsApp\nBlack-выгоды в местах\nПлан поездки под интересы\n−10 % на все услуги\n8 000 ₽ на услуги каталога',
          cta: 'Купить Dobro Black',
          priceNote: 'за поездку · на двоих',
          price: '16 000 ₽',
        },
        services: {
          prep: {
            title: 'Подготовка к приезду',
            description: 'Список документов и TDAC до вылета.',
            price: 'Бесплатно',
          },
          fastTrack: {
            title: 'Fast Track Standard',
            description: 'Быстрый проход паспортного контроля.',
            price: 'От 3 600 ₽',
          },
          fastTrackVip: {
            title: 'Fast Track VIP',
            description: 'Встреча у самолёта, багаж, таможня и выход к машине.',
            price: 'От 8 500 ₽',
          },
          transfer: {
            title: 'Личный трансфер',
            description: 'Из аэропорта в отель. Седан до 3 человек.',
            price: 'От 4 500 ₽',
          },
          tours: {
            title: 'Туры по островам',
            description: 'Морские прогулки и туры с партнёрами Dobro.',
            price: 'Цена партнёра',
          },
        },
        question: {
          title: 'Просто вопрос',
          priceNote: 'ответим за день',
          price: '—',
        },
      },

      howItWorks: {
        titleLead: 'Как работает',
        titleAccent: 'Dobro.',
        titleTail: '',
        lead: 'Оформите заказ до поездки. Мы готовим услуги из вашего пакета.',
        bannerTitle: 'От трапа до своих.',
        bannerNote: 'В этом и есть Dobro.',
        choose: {
          title: 'Выберите своё Dobro',
          description: 'Выберите Pass или Black,\nа затем нужные услуги.',
        },
        details: {
          title: 'Пришлите данные рейса',
          description: 'Номер рейса и адрес,\nгде вы остановитесь.',
        },
        arrive: {
          title: 'Прилетайте с Dobro',
          description: 'Услуги в аэропорту и трансфер\nждут вас в день прилёта.',
        },
      },

      features: {
        titleTop: 'Не карта скидок.',
        titleLead: 'Ключ к',
        titleAccent: 'Пхукету.',
        leadFirst: 'Начните с карты и добавьте только нужные услуги.',
        leadSecond: 'Любой вариант ведёт в те же хорошие места,',
        leadThird: 'к скидкам и людям, которые помогут.',
        pass: {
          title: 'Dobro Pass',
          description: 'Одна поездка до 30 дней с местами, скидками и привилегиями для своих.',
        },
        assist: {
          title: 'Встреча и Fast Track',
          description: 'Наш человек встречает вас в аэропорту и ведёт по быстрому маршруту. Цена за человека.',
        },
        transfer: {
          title: 'Личный трансфер',
          description: 'Мы следим за рейсом, а водитель везёт вас прямо до места проживания. Цена за машину.',
        },
        prep: {
          title: 'Подготовка к въезду',
          description: 'Понятный список документов и TDAC ещё до вылета. Бесплатно для всех.',
        },
        support: {
          title: 'Поддержка 24/7',
          description: 'Живой человек на связи круглосуточно, если планы приезда меняются.',
        },
      },

      places: {
        titleTop: 'Хорошие места',
        titleLead: 'собраны в',
        titleAccent: 'Dobro.',
        titleTail: '',
        leadFirst: 'Проверенные места по всему Пхукету',
        leadSecond: 'со скидками для участников Dobro.',
        categoriesLabel: 'Категории мест',
        previous: 'Предыдущие места',
        next: 'Следующие места',
        action: 'Смотреть все места Dobro',
        categories: {
          all: 'Все',
          coffee: 'Кофе',
          food: 'Еда',
          wellness: 'Спа',
          nightlife: 'Бары',
          activities: 'Развлечения',
        },
        bartels: {
          area: 'Спешелти кофе · Банг Тао',
          perk: 'Кофе бесплатно',
          detail: 'к любому завтраку',
        },
        suay: {
          area: 'Современный тай · Чернг Талай',
          perk: 'Скидка 10%',
          detail: 'на еду и напитки',
        },
        oasis: {
          area: 'Спа и велнес · Ката',
          perk: '+30 минут',
          detail: 'ароматерапии в подарок',
        },
        catch: {
          area: 'Пляжный клуб · Банг Тао',
          perk: 'Напиток в подарок',
          detail: 'при входе',
        },
        simba: {
          area: 'Морские туры · Чалонг',
          perk: 'Скидка 5%',
          detail: 'на туры по островам',
        },
        campus: {
          area: 'Обжарка кофе · Старый город',
          perk: 'Десерт в подарок',
          detail: 'к любому кофе',
        },
      },

      footer: {
        tagline: 'Карта в хорошие места, выгодные скидки и помощь с приездом на Пхукет.',
        request: 'Оставить заявку',
        explore: 'Разделы',
        howItWorks: 'Как работает',
        places: 'Добрые места',
        packages: 'Тарифы',
        faq: 'FAQ',
        brand: 'Dobroverse',
        about: 'О проекте',
        forPlaces: 'Для мест',
        contact: 'Контакты',
        getPass: 'Купить Dobro Pass',
        follow: 'Соцсети',
        followNote: 'Новые места, скидки и советы по Пхукету.',
        onInstagram: 'Dobroverse в Instagram',
        onTiktok: 'Dobroverse в TikTok',
        onFacebook: 'Dobroverse в Facebook',
        rights: '© 2026 Dobro Pass. Все права защищены.',
        terms: 'Оферта',
        privacy: 'Данные',
        madeIn: 'Сделано на Пхукете',
      },
    }
  }
};
